import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import CadastralFields from './CadastralFields'
import useCadastralFields from './useCadastralFields'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'

const CadastralFieldsModal = () => {
  const { t, hidden, isFilled, isOpen, openModal, closeModal } = useCadastralFields()

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='1rem'>
      {/* @ts-ignore */}
      <SDOutlineButton
        onClick={openModal}
        endEnhancer={isFilled ? () => <IconCarbonCheckmarkOutline size={24} color='green' /> : undefined}
      >
        {t('subscriptionForm:address_module.cadastral_fields.module_title')}
      </SDOutlineButton>

      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:address_module.cadastral_fields.module_title')}
        sections={<CadastralFields />}
      />
    </SpacingWrapper>
  )
}

export default CadastralFieldsModal
